import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { schedulingTask } from 'src/redux/actions/constant';
import therapistService from 'src/services/apiServices/therapist-scheduling/therapistService';

const {
  DELETE_TASK_NOTE_SCHEDULING_REQUEST,
  DELETE_TASK_NOTE_SCHEDULING_SUCCESS,
  DELETE_TASK_NOTE_SCHEDULING_FAILURE,
  DELETE_TASK_NOTE_SCHEDULING_LOADING,
  DELETE_TASK_NOTE_SCHEDULING_RESET,
} = schedulingTask;

function* deleteTaskNoteSchedular(action: any): SagaReturnType<any> {
  try {
    yield put({ type: DELETE_TASK_NOTE_SCHEDULING_LOADING });
    const response = yield call(therapistService.deleteTherapistTaskNote, action.payload);
    if (response?.status === 200) {
      yield put({ type: DELETE_TASK_NOTE_SCHEDULING_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: DELETE_TASK_NOTE_SCHEDULING_FAILURE, payload: error });
  }
}

function* deleteTaskNoteSchedularSaga() {
  yield takeEvery(DELETE_TASK_NOTE_SCHEDULING_REQUEST, deleteTaskNoteSchedular);
}

export default deleteTaskNoteSchedularSaga;
